var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notLoggedIn"},[_c('van-dialog',{attrs:{"title":"","show-cancel-button":"","message":'该操作需登录后使用('+_vm.messageTimer.count+'s)',"confirmButtonText":"去登录","cancelButtonText":"关闭"},on:{"confirm":_vm.determine,"cancel":_vm.cancel},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }